export function lessonNarrationText(lesson) {
  const written = (lesson.written_content || "").trim();
  if (written) return written.replace(/[#*_`>\-]/g, " ");
  const url = (lesson.audio_url || "").trim();
  if (url && lesson.audio_transcript_reviewed === true &&
      lesson.audio_transcript_source_url === url) return (lesson.audio_transcript || "").trim();
  return "";
}
